import { api_configuration } from "../../common";
import { shouldResetModifiedState } from "./SaveModifiedStatus";
import api_cs = api_configuration.types.client_state.alan_api;

export default function resetModifiedState(node: api_cs.Cnode, reset_collection: boolean): void {
	node.properties.is_busy_saving.ensure("no", {});
	for (const attribute of node.properties.attributes.values()) {
		const $att_type = attribute.properties.type.state;
		switch ($att_type.name) {
			case "operation":
				break;
			case "property": {
				const $property = $att_type.node.properties.type.state;
				switch ($property.name) {
					case "text":
						switch ($property.node.properties.is_editable.state.name) {
							case "no":
								break;
							case "yes": {
								const yes = $property.node.properties.is_editable.state.node;
								switch (yes.properties.modified.state.name) {
									case "no":
										break;
									case "yes": {
										const yes_modified = yes.properties.modified.state.node;
										if (shouldResetModifiedState(yes_modified)) {
											$property.node.properties.is_editable.state.node.properties.modified.ensure("no", {});
										}
										break;
									}
								}

								break;
							}
						}
						break;
					case "number":
						switch ($property.node.properties.is_editable.state.name) {
							case "no":
								break;
							case "yes": {
								const yes = $property.node.properties.is_editable.state.node;
								switch (yes.properties.modified.state.name) {
									case "no":
										break;
									case "yes": {
										const yes_modified = yes.properties.modified.state.node;
										if (shouldResetModifiedState(yes_modified)) {
											$property.node.properties.is_editable.state.node.properties.modified.ensure("no", {});
											switch ($property.node.properties.backend_known.state.name) {
												case "no":
													$property.node.properties.is_set.ensure("no", {});
													break;
												case "yes":
													break;
											}
										}
										break;
									}
								}
								break;
							}
						}
						break;
					case "file":
						switch ($property.node.properties.is_editable.state.name) {
							case "no":
								break;
							case "yes": {
								const yes = $property.node.properties.is_editable.state.node;
								switch (yes.properties.modified.state.name) {
									case "no":
										break;
									case "yes": {
										const yes_modified = yes.properties.modified.state.node;
										if (shouldResetModifiedState(yes_modified)) {
											$property.node.properties.is_editable.state.node.properties.modified.ensure("no", {});
										}
										break;
									}
								}
								break;
							}
						}
						break;
					case "group":
						resetModifiedState($property.node.properties.node, reset_collection);
						break;
					case "state group":
						switch ($property.node.properties.is_modified.state.name) {
							case "no":
								break;
							case "yes": {
								{
									const yes_is_modified = $property.node.properties.is_modified.state.node;
									if (shouldResetModifiedState(yes_is_modified)) {
										$property.node.properties.is_modified.ensure("no", {});
									}
									break;
								}
							}
						}
						for (const state of $property.node.properties.states.values()) {
							resetModifiedState(state.properties.node, reset_collection);
						}
						break;
					case "collection":
						if (reset_collection) {
							resetCollectionModifiedState($property.node, reset_collection);
						}
						break;
				}
			}
		}
	}
}

export function resetCollectionModifiedState(collection: api_cs.Ccollection, reset_collection: boolean): void {
	for (const entry of collection.properties.entries.values()) {
		resetModifiedState(entry.properties.node, reset_collection);
	}
}
